import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetFilters } from '../redux/slicers/admin/sidebarSlicer';
import { filterActions, selectFilterBy, selectSearch, selectSortBy } from '../redux/slicers/filters/filterSlicer';
import { selectSearchTags } from '../redux/slicers/search/searchSlicer';
import { useInfoDialogaActions } from './useInfoDialogaActions';

export const useDataListActions = ({
  items,
  itemDeleteText,
  itemsDeleteText,
  deleteAction,
  bulkDeleteAction,
  defaultSort,
  defaultFilterBy,
  useGlobalFilter,
}) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const [sortBy, setSortBy] = useState(defaultSort);
  const [filterBy, setFilterBy] = useState(defaultFilterBy || undefined);
  const [search, setSearch] = useState('');

  const globalFilterBy = useSelector(selectFilterBy) || defaultFilterBy;
  let globalSortBy = useSelector(selectSortBy) || defaultSort;
  const globalSearch = useSelector(selectSearch);

  if (!globalSortBy || globalSortBy?.value === null) {
    globalSortBy = defaultSort;
  }

  useEffect(() => {
    // TODO:  remove selected items from the list if they are not in the new items list
    const itemIdList = items.map(i => i.id);
    const newSelected = selected.filter(id => itemIdList.includes(id));
    setSelected(newSelected)
  }, [items]);

  const { openInfoDialog } = useInfoDialogaActions();

  const onDelete = (id) => {
    const ids = id ? [id] : selected;

    if (!ids.length) return;

    const dialogContent = ids.length === 1 ? itemDeleteText : itemsDeleteText(ids);

    // TODO: handle multiple deletions
    openInfoDialog({
      title: 'Delete',
      description: dialogContent,
      cancelButtonText: 'No',
      buttonText: 'Yes',
      onButtonClick: () => {
        if (ids.length > 1 && bulkDeleteAction) {
          dispatch(bulkDeleteAction(ids));
          return;
        }

        ids.forEach((id) => {
          dispatch(deleteAction(id));
        });
      },
    });
  };

  const toggleAll = () => {
    const allSelected = selected.length === items.length;
    allSelected ? setSelected([]) : setSelected(items.map((item) => item.id));
  };

  const toggleItem = (id, setAllId = false) => {
    window.$restrictFilter = null
    if(setAllId === true){
      setSelected(Object.values(id));
      return
    }
    if (selected.includes(id)) {
      setSelected(selected.filter((selectedId) => selectedId !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  const toggleSingleItem = (id) => {
    window.$restrictFilter = null
    if(selected.includes(id)) {
      setSelected([]);
    }
    else {
      setSelected([id]);
    }
  };

  const resetSelection = () => setSelected([]);

  const onSortChange = (sortBy) => {
    window.$restrictFilter = null
    if (useGlobalFilter) {
      dispatch(filterActions.setSortBy(sortBy))
    } else {
      setSortBy(sortBy);
    }
  };

  const onFilterByChange = (filterBy) => {
    window.$restrictFilter = null
    if (useGlobalFilter) {
      dispatch(filterActions.setFilterBy(filterBy))
      // I comment below code beacouse it's reset the filter label UI only when we select any filter from dropdown of topbar
      // https://app.clickup.com/t/3326989/DEV-24752
      // dispatch(resetFilters());
    } else {
      setFilterBy(filterBy);
    }
  };

  const onSearchChange = (value) => {
    const val = typeof value === 'string' ? value : value.target.value;
    if (useGlobalFilter) {
      dispatch(filterActions.setSearch(value))
    } else {
      setSearch(val);
    }
  };

  const tags = useSelector(selectSearchTags)

  useEffect(() => {
    if (!items?.length) return
    const tempSelected = selected.filter((ids) => items?.find((item) => item?.id === ids))
    setSelected([...tempSelected])
  }, [items]);

  return {
    selected,
    sortBy: useGlobalFilter ? globalSortBy : sortBy,
    filterBy: useGlobalFilter ? globalFilterBy : filterBy,
    search: useGlobalFilter ? globalSearch : search,
    tags,
    anySelected: selected.length > 0,
    onDelete,
    toggleAll,
    toggleSingleItem,
    toggleItem,
    resetSelection,
    hasSelected: selected.length > 0,
    deleteDisabled: selected.length === 0,
    allSelected: items.length > 0 && selected.length === items.length, // TODO: work on this logic, it's better to compare map of ids
    onSortChange,
    onFilterByChange,
    onSearchChange,
  };
};
